module.exports = __webpack_public_path__ + "img/pt-28.ee0d0df9.jpg";